import * as endpoints from './endpoints';
import getOpenTasksForPeriods from './actions/getOpenTasksForPeriods';
import { escalateToClinician } from './actions/escalateToClinician';
import { snoozeTask, resumeTask } from './actions/snoozeTask';
import { completeLabReview } from './actions/completeLabReview';

const TaskService = {
  ...endpoints,
  getOpenTasksForPeriods,
  escalateToClinician,
  snoozeTask,
  resumeTask,
  completeLabReview,
};

export default TaskService;
export type {
  TaskInstance,
  OpenTasksOpts,
  PaginatedClosedTasks,
  TaskHistoryOpts,
  TaskHistory,
  ClinicCallRead,
  CreateTaskPayload,
  CompletionActor,
} from './endpoints';
export type { EscalateOpts } from './actions/escalateToClinician';
export type { SnoozeOpts } from './actions/snoozeTask';
export type { CompleteLabReviewOpts, CompleteLabReviewResult } from './actions/completeLabReview';
